import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });

  // If token already exists, skip login and go straight to dashboard
  useEffect(() => {
    if (localStorage.getItem("admin_token")) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      // Replace with your actual API endpoint
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "OrgId": "resh-dev" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok || data.status !== 200) {
        throw new Error(data.error_msg || data.message || "Invalid credentials");
      }
      const { token, name, role } = data.data;
      localStorage.setItem("admin_token", token);
      localStorage.setItem("admin_name", name);
      localStorage.setItem("admin_role", role);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__header">
          <img src="/logo.png" alt="Resh Photography" className="login-card__logo" />
          <h1 className="login-card__title">Resh Photography</h1>
          <p className="login-card__subtitle">Admin Portal</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <div className="login-form__group">
            <label className="login-form__label" htmlFor="email">Email</label>
            <input
              id="email"
              className="login-form__input"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="admin@reshphotography.com"
              autoComplete="email"
            />
          </div>

          <div className="login-form__group">
            <label className="login-form__label" htmlFor="password">Password</label>
            <div className="login-form__input-wrap">
              <input
                id="password"
                className="login-form__input"
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-form__toggle"
                onClick={() => setShowPassword((p) => !p)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {error && <p className="login-form__error">{error}</p>}

          <button className="login-form__btn" type="submit" disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
